import React from "react";
import { observer } from "mobx-react";
import { Form, Input } from "antd";
import BaseModal from "@app/components/modal";
import notify from "@app/components/notify";

const RenameModal = observer(({ initialValue, onClose, onSave }) => {
    const [form] = Form.useForm();

    /**
     * Handle the dialog close event
     */
    function handleClose() {
        onClose();
    }

    function handleSave(data) {
        onSave(data);
    }

    /**
     * Show the validation error
     */
    const validationError = () => {
        notify.error("Please fill all required fields to continue");
    };

    return (
        <BaseModal
            title="Rename a chat"
            visible={true}
            okText="Save"
            onOk={() => form.submit()}
            onCancel={handleClose}
        >
            <Form
                layout="vertical"
                form={form}
                onFinishFailed={validationError}
                onFinish={handleSave}
            >
                <Form.Item
                    label="Chat Name"
                    initialValue={initialValue}
                    name="name"
                    rules={[
                        {
                            required: true,
                            whitespace: true,
                            message: "Please enter chat name",
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </BaseModal>
    );
});

export default RenameModal;
